export default __webpack_public_path__ + "static/media/second_section_c.a50c3592.png";